module.exports = __webpack_public_path__ + "img/work.ea498396.png";